import React from "react";
import CuentasBancariasBase from "./CuentasBancariasBase";

export default function TarjetasCredito() {
  return <CuentasBancariasBase tipo="TarjetaCredito" />;
}
